import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { ArrowRight, Phone, HelpCircle, ChevronDown } from 'lucide-react';

const faqData = [
  {
    q_fr: "Puis-je obtenir un pret auto avec un mauvais credit?",
    a_fr: "Oui! Credit Auto Reset se specialise dans le financement 2e et 3e chance. Nous avons un taux d'approbation de 99%, meme pour les personnes avec mauvais credit, faillite ou refus bancaire. Nous travaillons avec la plupart des banques et institutions financieres au Canada.",
    q_en: "Can I get a car loan with bad credit?",
    a_en: "Yes! Credit Auto Reset specializes in 2nd and 3rd chance financing. We have a 99% approval rate, even for people with bad credit, bankruptcy, or bank refusals. We work with most banks and financial institutions in Canada."
  },
  {
    q_fr: "Combien de mise de fonds est requise?",
    a_fr: "Nous offrons des options de financement avec 0$ comptant. Selon votre dossier, certaines institutions peuvent demander une mise de fonds, mais nous travaillons pour minimiser ce montant le plus possible.",
    q_en: "How much down payment is required?",
    a_en: "We offer financing options with $0 down. Depending on your file, some lenders may require a down payment, but we work to minimize that amount as much as possible."
  },
  {
    q_fr: "Puis-je avoir un financement auto apres une faillite?",
    a_fr: "Absolument. Meme si vous etes en faillite active ou recemment liberee, nous avons des solutions. Nos institutions financieres partenaires offrent des programmes specifiques pour les personnes en retablissement de credit apres faillite.",
    q_en: "Can I get auto financing after bankruptcy?",
    a_en: "Absolutely. Even if you're in active bankruptcy or recently discharged, we have solutions. Our partner financial institutions offer specific programs for people rebuilding credit after bankruptcy."
  },
  {
    q_fr: "Combien de temps prend l'approbation?",
    a_fr: "Notre equipe traite les demandes rapidement. La plupart des clients recoivent une reponse dans les 24 heures suivant leur demande. Dans certains cas, l'approbation peut etre obtenue le jour meme.",
    q_en: "How long does approval take?",
    a_en: "Our team processes applications quickly. Most clients receive a response within 24 hours of their application. In some cases, approval can be obtained the same day."
  },
  {
    q_fr: "Quels documents sont necessaires pour faire une demande?",
    a_fr: "Vous aurez besoin d'une piece d'identite avec photo, vos releves bancaires recents, vos talons de paie, et une preuve de residence. Notre equipe vous guidera a travers le processus.",
    q_en: "What documents are needed to apply?",
    a_en: "You'll need a photo ID, recent bank statements, pay stubs, and proof of residence. Our team will guide you through the process."
  },
  {
    q_fr: "Est-ce que le financement aide a retablir mon credit?",
    a_fr: "Oui! Chaque paiement effectue a temps est rapporte aux agences de credit (Equifax et TransUnion). Apres quelques mois de paiements reguliers, vous verrez votre cote de credit s'ameliorer progressivement.",
    q_en: "Does financing help rebuild my credit?",
    a_en: "Yes! Every on-time payment is reported to credit agencies (Equifax and TransUnion). After a few months of regular payments, you'll see your credit score gradually improve."
  },
  {
    q_fr: "Quels types de vehicules offrez-vous?",
    a_fr: "Nous offrons une grande selection de vehicules d'occasion de qualite: berlines, VUS, camions, pickup et plus. Nous vous aidons a trouver le vehicule qui correspond a vos besoins et votre budget.",
    q_en: "What types of vehicles do you offer?",
    a_en: "We offer a wide selection of quality used vehicles: sedans, SUVs, trucks, pickups and more. We help you find the vehicle that matches your needs and budget."
  },
  {
    q_fr: "Ou etes-vous situes?",
    a_fr: "Notre concessionnaire est situe au 1007 Boulevard Rene-Levesque, Verdun (Montreal), Iles-des-Soeurs. Nous desservons tout le Quebec et vous faisons deplacer qu'une seule fois pour la selection de votre vehicule et la prise de possession.",
    q_en: "Where are you located?",
    a_en: "Our dealership is located at 1007 Boulevard Rene-Levesque, Verdun (Montreal), Iles-des-Soeurs. We serve all of Quebec and you only need to come once for vehicle selection and pickup."
  },
  {
    q_fr: "Puis-je faire une demande en ligne?",
    a_fr: "Oui! Vous pouvez faire une demande directement sur notre site web, clavarder avec Alex notre assistant en ligne, ou nous appeler au 514-418-3968. Le processus est simple, rapide et sans engagement.",
    q_en: "Can I apply online?",
    a_en: "Yes! You can apply directly on our website, chat with Alex our online assistant, or call us at 514-418-3968. The process is simple, fast and no obligation."
  },
  {
    q_fr: "Est-ce que je peux choisir mon vehicule?",
    a_fr: "Bien sur! Une fois votre dossier approuve, notre equipe vous aide a selectionner le vehicule qui correspond le mieux a vos besoins, votre budget et vos preferences. Nous avons des centaines de vehicules disponibles.",
    q_en: "Can I choose my vehicle?",
    a_en: "Of course! Once your file is approved, our team helps you select the vehicle that best matches your needs, budget and preferences. We have hundreds of vehicles available."
  },
  {
    q_fr: "Quel est le taux d'interet pour un financement 2e chance?",
    a_fr: "Les taux varient selon votre dossier de credit. Pour un mauvais credit, les taux se situent generalement entre 10.99% et 29.99%. Notre objectif est de vous obtenir le meilleur taux possible et de vous aider a le reduire avec le temps.",
    q_en: "What is the interest rate for 2nd chance financing?",
    a_en: "Rates vary depending on your credit file. For bad credit, rates generally range from 10.99% to 29.99%. Our goal is to get you the best possible rate and help you reduce it over time."
  },
  {
    q_fr: "Acceptez-vous les travailleurs autonomes?",
    a_fr: "Oui! Nous avons des programmes adaptes aux travailleurs autonomes, aux contractuels et aux pigistes. Vous devrez fournir vos avis de cotisation et des preuves de revenus recentes.",
    q_en: "Do you accept self-employed workers?",
    a_en: "Yes! We have programs adapted for self-employed workers, contractors and freelancers. You'll need to provide your tax assessments and recent proof of income."
  },
  {
    q_fr: "Puis-je avoir un financement auto en tant que nouvel immigrant?",
    a_fr: "Oui! Nous avons des solutions pour les nouveaux arrivants au Canada, meme sans historique de credit canadien. Apportez votre permis de travail ou residence permanente, une preuve d'emploi et vos documents d'identite.",
    q_en: "Can I get auto financing as a new immigrant?",
    a_en: "Yes! We have solutions for newcomers to Canada, even without Canadian credit history. Bring your work permit or permanent residence, proof of employment and ID documents."
  },
  {
    q_fr: "Est-ce que je dois me deplacer pour faire ma demande?",
    a_fr: "Non! Toute la demande se fait en ligne ou par telephone. Vous ne vous deplacez qu'une seule fois, pour choisir votre vehicule et en prendre possession a notre concessionnaire de Montreal (Iles-des-Soeurs).",
    q_en: "Do I need to come in person to apply?",
    a_en: "No! The entire application is done online or by phone. You only come once, to choose your vehicle and pick it up at our Montreal dealership (Iles-des-Soeurs)."
  },
  {
    q_fr: "Quelles banques travaillent avec vous?",
    a_fr: "Nous travaillons avec Desjardins, TD, Scotiabank, iA Financial, Eden Park, Santander, Iceberg Finance et plusieurs autres institutions financieres. Cela nous permet de trouver la meilleure offre pour votre situation.",
    q_en: "Which banks do you work with?",
    a_en: "We work with Desjardins, TD, Scotiabank, iA Financial, Eden Park, Santander, Iceberg Finance and several other financial institutions. This allows us to find the best offer for your situation."
  }
];

const FAQPage = () => {
  const { language } = useLanguage();
  const [openIndex, setOpenIndex] = React.useState(null);

  useEffect(() => {
    document.title = language === 'en'
      ? 'FAQ - Auto Financing Questions | Credit Auto Reset Quebec'
      : 'FAQ - Questions Financement Auto | Credit Auto Reset Quebec';
    document.querySelector('meta[name="description"]')?.setAttribute('content',
      language === 'en'
        ? 'Frequently asked questions about auto financing with bad credit in Quebec. Learn about 2nd chance credit, approval rates, documents needed, and more.'
        : 'Questions frequentes sur le financement auto avec mauvais credit au Quebec. Apprenez sur le credit 2e chance, taux d\'approbation, documents requis, et plus.'
    );
  }, [language]);

  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="bg-gradient-to-r from-[#1a5c3b] to-[#16a085] py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <HelpCircle className="w-12 h-12 text-white mx-auto mb-4" />
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
            {language === 'en' ? 'Frequently Asked Questions' : 'Questions Fréquentes'}
          </h1>
          <p className="text-white/90 text-lg max-w-2xl mx-auto">
            {language === 'en'
              ? 'Everything you need to know about auto financing with Credit Auto Reset'
              : 'Tout ce que vous devez savoir sur le financement auto avec Credit Auto Reset'}
          </p>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4">
          <div className="space-y-3">
            {faqData.map((faq, i) => {
              const question = language === 'en' ? faq.q_en : faq.q_fr;
              const answer = language === 'en' ? faq.a_en : faq.a_fr;
              const isOpen = openIndex === i;
              return (
                <div key={i} className="border border-gray-200 rounded-xl overflow-hidden" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50 transition-colors"
                  >
                    <span className="font-semibold text-gray-900 pr-4">{question}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                  </button>
                  {isOpen && (
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-3">
                      {answer}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-[#1a5c3b] to-[#16a085]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            {language === 'en' ? 'Still Have Questions?' : 'Vous avez d\'autres questions?'}
          </h2>
          <p className="text-white/90 mb-6">
            {language === 'en'
              ? 'Chat with Alex, our online assistant, or call us directly.'
              : 'Clavardez avec Alex, notre assistant en ligne, ou appelez-nous directement.'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/demander-un-pret-auto">
              <Button size="lg" className="bg-white text-[#1a5c3b] hover:bg-gray-100 font-bold px-8">
                {language === 'en' ? 'Apply Now' : 'Faire une demande'}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <a href="tel:514-418-3968">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10 font-bold px-8">
                <Phone className="mr-2 w-5 h-5" />
                514-418-3968
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Service Areas Internal Links */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-xl font-bold text-gray-900 mb-6 text-center">
            {language === 'en' ? 'We Serve All of Quebec' : 'Nous desservons tout le Quebec'}
          </h2>
          <div className="flex flex-wrap justify-center gap-2">
            {[
              { to: '/financement-auto-montreal', label: 'Montreal' },
              { to: '/financement-auto-laval', label: 'Laval' },
              { to: '/financement-auto-longueuil', label: 'Longueuil' },
              { to: '/financement-auto-brossard', label: 'Brossard' },
              { to: '/financement-auto-rive-sud', label: 'Rive-Sud' },
              { to: '/financement-auto-terrebonne', label: 'Terrebonne' },
              { to: '/financement-auto-repentigny', label: 'Repentigny' },
              { to: '/financement-auto-gatineau', label: 'Gatineau' },
              { to: '/financement-auto-quebec', label: 'Quebec' },
              { to: '/financement-auto-trois-rivieres', label: 'Trois-Rivieres' },
              { to: '/financement-auto-sherbrooke', label: 'Sherbrooke' },
              { to: '/financement-auto-drummondville', label: 'Drummondville' },
              { to: '/financement-auto-saint-jean', label: 'Saint-Jean' },
            ].map((city, i) => (
              <Link key={i} to={city.to} className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-[#1a5c3b] hover:bg-[#1a5c3b] hover:text-white transition-colors font-medium">
                {city.label}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
